<template>
  <el-col :span="2">
    <Steps :stepIndex="index"></Steps>
  </el-col>    
</template>

<script>
export default {
    name: 'SideBar',
    props: {
      'index': {
        type: Number,
        default: 1,
      }
    },
}
</script>